import baseHttp from '@/plugins/baseHttp';

export const createStore = (storeData,) => {
  return baseHttp.post('stores', storeData,);
};

export const fetchStore = (storeId,) => {
  return baseHttp.get(`stores/${storeId}`,);
};

export const duplicateStore = (storeId, formData,) => {

  const { franchiseId, copyMenu, } = formData;
  delete formData.franchiseId;
  delete formData.copyMenu;
  delete formData.currentFranchise;

  return baseHttp.post(`stores/${storeId}/duplicate?duplicateProducts=${copyMenu? 1 : 0}`, formData, {
    headers: {
      franchise: franchiseId,
    },
  },);
};

export const getCompanyBanks = (notAllowedBanks = [],) => {
  return baseHttp.get(`/companies/payments/available-banks?notIn=${notAllowedBanks.join(',',)}`,);
};

export const getStatesAndCities = (franchiseId,) => {
  return baseHttp.get(`/address/cities/franchises?id=${franchiseId}`,);
};

export const getDistricts = (cityId,) => {
  return baseHttp.get(`/address/districts/${cityId}`,);
};

export const getChecklist = (storeId,) => {
  return baseHttp.get(`/stores/${storeId}/checklist`,);
};

const getFranchiseHeaderConfig = (franchiseId,) => {
  return franchiseId ? {
    headers: {
      franchise: franchiseId,
    },
  } : {};
};

export const getPaymentMethods = (storeId, franchiseId,) => {
  return baseHttp.get(
    `/stores/payments/methods/${storeId}`,
    getFranchiseHeaderConfig(franchiseId,),
  );
};

export const patchPaymentMethods = (storeId, body,) => {
  return baseHttp.patch(`/stores/payments/methods/${storeId}`, body,);
};
export const patchExclusivePaymentMethod = (storeId, body,) => {
  return baseHttp.patch(`/stores/${storeId}/exclusive-online-payment`, body,);
};

export const getStoreOrders = (id,) => {
  return baseHttp.get(
    `/logistic/orders/recent?store.id=${id}&fields=code,created_at,delivery_form.price,tracking_info.tracking_status,tracking_info.task_id`,
  );
};

export const handleError = (error,) => {
  return baseHttp.handleError(error, error.response?.status === 400,);
};

export const publishStatus = (storeId, publishStatus,) => {
  return baseHttp.post(`/stores/${storeId}/publish-status`, {
    publishStatus,
  },);
};

export const validateBankAccount = (storeId,) => {
  return baseHttp.post(`stores/${storeId}/validate-bank-account`,);
};

export const patchBankAccount = (storeId, secondaryBankAccount,) => {
  return baseHttp.patch(`stores/${storeId}/bank-account`, secondaryBankAccount,);
};

export const updateStore = (storeId, storeData,) => {
  return baseHttp.patch(`stores/${storeId}`, storeData,);
};

export const updateStoreImage = (storeId, formData,) => {
  return baseHttp.patch(`stores/${storeId}/photo`, formData,);
};

export const updateStoreStatusToSuspended = (storeId, reason,) => {
  return baseHttp.post(`stores/${storeId}/suspend`, reason,);
};

export const updateStoreStatusToClosed = (storeId, reason,) => {
  return baseHttp.post(`stores/${storeId}/close`, reason,);
};

export const patchOpeningTime = (storeId, body,) => {
  return baseHttp.patch(`/stores/opening-time/${storeId}`, body,);
};
export const postOpeningTime = (storeId, body,) => {
  return baseHttp.post(`/stores/opening-time/${storeId}`, body,);
};

// Delivery Area
export const postBasePlan = (storeId,) => {
  return baseHttp.post(`/delivery-plans/store/${storeId}/base-plan`,);
};

export const getBasePlan = (storeId,) => {
  return baseHttp.get(`/delivery-plans/store/${storeId}/base-plan/detailed`,);
};

export const forceBasePlan = (storeId,) => {
  return baseHttp.post(`/delivery-plans/store/${storeId}/base-plan/force`,);
};

export const putBasePlan = (storeId, body,) => {
  return baseHttp.put(`/delivery-plans/store/${storeId}/base-plan`, body,);
};

export const postPromoPlan = (storeId, body,) => {
  return baseHttp.post(`/delivery-plans/store/${storeId}/promo-plan`, body,);
};

export const getPromoPlans = (storeId,) => {
  return baseHttp.get(`/delivery-plans/store/${storeId}/promo-plan`,);
};

export const deletePromoPlan = (storeId, promoPlanId,) => {
  return baseHttp.delete(`/delivery-plans/store/${storeId}/promo-plan/${promoPlanId}`,);
};

export const getDistrictsByStore = (storeId,) => {
  return baseHttp.get(`/delivery-plans/store/${storeId}/districts`,);
};

export const financialStatus = (storeId, body,) => {
  return baseHttp.patch(`/stores/${storeId}/financial-status`, body,);
};

// Store Products
export const getStoreProducts = (data,) => {
  return baseHttp.get('/store-products', {
    params: {
      company_uuid: data.company_uuid,
    },
  },);
};

export const createStoreProduct = (data,) => {
  return baseHttp.post('/store-products', data,);
};

export const disableStoreProduct = (productId,) => {
  return baseHttp.patch(`/store-products/${productId}/disable`,);
};

export const indexCompany = (companyUuid,) => {
  return baseHttp.patch(`/indexing/${companyUuid}/enable`,);
};

export const deindexCompany = (companyUuid,) => {
  return baseHttp.patch(`/indexing/${companyUuid}/disable`,);
};
